export const getWind2EventNestedXML = data => {
  if (!data || data.length === 0) {
    return ''
  }
  const xmlString = []
  xmlString.push('<EventList>')
  data.forEach(element => {
    xmlString.push('\n\t<Event>')
    element.plantId &&
      xmlString.push('\n\t\t<PlantID>' + element.plantId + '</PlantID>')
    element.eventId &&
      xmlString.push('\n\t\t<EventID>' + element.eventId + '</EventID>')
    element.eventstartTimeZone &&
      xmlString.push(
        '\n\t\t<TimeZone>' + element.eventstartTimeZone + '</TimeZone>'
      )
    element.eventstart &&
      xmlString.push('\n\t\t<StartDT>' + element.eventstart + '</StartDT>')
    element.eventend &&
      xmlString.push('\n\t\t<EndDT>' + element.eventend + '</EndDT>')
    element.eventtype &&
      xmlString.push('\n\t\t<EventType>' + element.eventtype + '</EventType>')
    element.causecode &&
      xmlString.push('\n\t\t<CauseCode>' + element.causecode + '</CauseCode>')
    const extension = element.extension

    if (extension && Object.keys(extension).length > 0) {
      xmlString.push('\n\t\t<AdditionalCauseCode>')
      extension.causecode1 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode1 + '</CauseCode>'
        )
      extension.causecode2 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode2 + '</CauseCode>'
        )
      extension.causecode3 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode3 + '</CauseCode>'
        )
      extension.causecode4 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode4 + '</CauseCode>'
        )
      extension.causecode5 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode5 + '</CauseCode>'
        )
      extension.causecode6 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode6 + '</CauseCode>'
        )
      extension.causecode7 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode7 + '</CauseCode>'
        )
      extension.causecode8 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode8 + '</CauseCode>'
        )
      extension.causecode9 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode9 + '</CauseCode>'
        )
      extension.causecode10 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode10 + '</CauseCode>'
        )
      xmlString.push('\n\t\t</AdditionalCauseCode>')
    }

    element.contributingCondition &&
      xmlString.push(
        '\n\t\t<Condition>' + element.contributingCondition + '</Condition>'
      )
    element.description &&
      xmlString.push(
        '\n\t\t<Description>' + element.description + '</Description>'
      )
    element.potentialLoss &&
      xmlString.push('\n\t\t<MWHLoss>' + element.potentialLoss + '</MWHLoss>')
    xmlString.push('\n\t</Event>')
  })
  xmlString.push('\n</EventList>')
  return xmlString.join('')
}

// const wind_event_nested_data = [
//   {
//     plantId: 'abc',
//     eventId: 'abc',
//     eventstartTimeZone: 'EST',
//     eventstart: '9:00PM',
//     eventend: '10:00PM',
//     eventtype: 'xyz',
//     causecode: 'xyz',
//     extension: [
//       {
//         causecode1: 'xyz1',
//         causecode2: 'xyz2',
//         causecode3: 'xyz3',
//         causecode4: 'xyz4',
//         causecode5: 'xyz5',
//         causecode6: 'xyz6',
//         causecode7: 'xyz7',
//         causecode8: 'xyz8',
//         causecode9: 'xyz9',
//         causecode10: 'xyz10',
//       },
//       {
//         causecode1: 'xyz1',
//         causecode2: 'xyz2',
//         causecode3: 'xyz3',
//         causecode4: 'xyz4',
//         causecode5: 'xyz5',
//         causecode6: 'xyz6',
//         causecode7: 'xyz7',
//         causecode8: 'xyz8',
//         causecode9: 'xyz9',
//         causecode10: 'xyz10',
//       },
//     ],
//     contributingCondition: 'anything',
//     description: 'abcbabcbabbcbabbcbacb',
//     potentialLoss: 'loss',
//   },
// ]

export const getWind2SubgroupPerformanceXML = data => {
  if (!data || data.length === 0) {
    return ''
  }
  const xmlString = []
  xmlString.push('<SubGroupPerformanceList>')
  data.forEach(element => {
    xmlString.push('\n\t<SubGroupPerformance>')
    element.plantId &&
      xmlString.push('\n\t\t<PlantID>' + element.plantId + '</PlantID>')
    element.subgroupId &&
      xmlString.push(
        '\n\t\t<SubGroupID>' + element.subgroupId + '</SubGroupID>'
      )
    element.month &&
      xmlString.push('\n\t\t<ReptMonth>' + element.month + '</ReptMonth>')
    element.year &&
      xmlString.push('\n\t\t<ReptYear>' + element.year + '</ReptYear>')
    element.status &&
      xmlString.push('\n\t\t<SGStatus>' + element.status + '</SGStatus>')
    element.grossactgen &&
      xmlString.push('\n\t\t<GAG>' + element.grossactgen + '</GAG>')
    element.expectedGen &&
      xmlString.push('\n\t\t<EG>' + element.expectedGen + '</EG>')
    element.netactgen &&
      xmlString.push('\n\t\t<NAG>' + element.netactgen + '</NAG>')
    element.netmaxcap &&
      xmlString.push('\n\t\t<NMC>' + element.netmaxcap + '</NMC>')
    element.activeThrs &&
      xmlString.push('\n\t\t<ACTH>' + element.activeThrs + '</ACTH>')
    element.contactThrs &&
      xmlString.push('\n\t\t<CTH>' + element.contactThrs + '</CTH>')
    element.rsThrs &&
      xmlString.push('\n\t\t<RSTH>' + element.rsThrs + '</RSTH>')
    element.forcedThrs &&
      xmlString.push('\n\t\t<FTH>' + element.forcedThrs + '</FTH>')
    element.maintenanceThrs &&
      xmlString.push('\n\t\t<MTH>' + element.maintenanceThrs + '</MTH>')
    element.plannedThrs &&
      xmlString.push('\n\t\t<PTH>' + element.plannedThrs + '</PTH>')
    element.ruThrs &&
      xmlString.push('\n\t\t<RUTH>' + element.ruThrs + '</RUTH>')
    element.inactiveReserveThrs &&
      xmlString.push('\n\t\t<IRTH>' + element.inactiveReserveThrs + '</IRTH>')
    element.mothballedThrs &&
      xmlString.push('\n\t\t<MBTH>' + element.mothballedThrs + '</MBTH>')
    element.retiredThrs &&
      xmlString.push('\n\t\t<RTH>' + element.retiredThrs + '</RTH>')
    xmlString.push('\n\t</SubGroupPerformance>')
  })
  xmlString.push('\n</SubGroupPerformanceList>')
  return xmlString.join('')
}

// const wind_subgroup_performacne_data = [
//   {
//     plantId: 'plantId',
//     subgroupId: 'subgroupId',
//     month: 'month',
//     year: 'year',
//     status: 'status',
//     grossactgen: 'grossactgen',
//     expectedGen: 'expectedGen',
//     netactgen: 'netactgen',
//     netmaxcap: 'netmaxcap',
//     activeThrs: 'activeThrs',
//     contactThrs: 'contactThrs',
//     rsThrs: 'rsThrs',
//     forcedThrs: 'forcedThrs',
//     maintenanceThrs: 'maintenanceThrs',
//     plannedThrs: 'plannedThrs',
//     ruThrs: 'ruThrs',
//     inactiveReserveThrs: 'inactiveReserveThrs',
//     mothballedThrs: 'mothballedThrs',
//     retiredThrs: 'retiredThrs',
//   },
// ]
//

export const getWind2PlantXML = data => {
  if (!data || data.length === 0) {
    return ''
  }
  const xmlString = []
  xmlString.push('<WindPlantList>')
  data.forEach(element => {
    xmlString.push('\n\t<WindPlant>')
    element.entityId &&
      xmlString.push('\n\t\t<EntityID>' + element.entityId + '</EntityID>')
    element.plantId &&
      xmlString.push('\n\t\t<PlantID>' + element.plantId + '</PlantID>')
    element.plantName &&
      xmlString.push('\n\t\t<PlantName>' + element.plantName + '</PlantName>')
    element.eiaPlantCode &&
      xmlString.push('\n\t\t<EIACode>' + element.eiaPlantCode + '</EIACode>')
    element.isoResourceId &&
      xmlString.push(
        '\n\t\t<PlantISOID>' + element.isoResourceId + '</PlantISOID>'
      )
    element.country &&
      xmlString.push('\n\t\t<Country>' + element.country + '</Country>')
    element.nearestCity &&
      xmlString.push('\n\t\t<NearCity>' + element.nearestCity + '</NearCity>')
    element.stateProvince &&
      xmlString.push('\n\t\t<State>' + element.stateProvince + '</State>')
    element.timeZone &&
      xmlString.push('\n\t\t<TimeZone>' + element.timeZone + '</TimeZone>')
    element.latitude &&
      xmlString.push(
        '\n\t\t<PlantLatitude>' + element.latitude + '</PlantLatitude>'
      )
    element.longitude &&
      xmlString.push(
        '\n\t\t<PlantLongitude>' + element.longitude + '</PlantLongitude>'
      )
    element.plantCapPoi &&
      xmlString.push('\n\t\t<CPOI>' + element.plantCapPoi + '</CPOI>')
    element.onSiteStorage &&
      xmlString.push(
        '\n\t\t<OnsiteStorage>' + element.onSiteStorage + '</OnsiteStorage>'
      )
    element.plantOwnershipStatus &&
      xmlString.push(
        '\n\t\t<PlantOwnStatus>' +
          element.plantOwnershipStatus +
          '</PlantOwnStatus>'
      )
    element.effectiveDate &&
      xmlString.push(
        '\n\t\t<PlantEffDate>' + element.effectiveDate + '</PlantEffDate>'
      )
    xmlString.push('\n\t</WindPlant>')
  })
  xmlString.push('\n</WindPlantList>')
  return xmlString.join('')
}

// const wind_plant_list_data = [
//   {
//     entityId: 'entityId',
//     plantId: 'plantId',
//     plantName: 'plantName',
//     eiaPlantCode: 'eiaPlantCode',
//     isoResourceId: 'isoResourceId',
//     country: 'country',
//     nearestCity: 'nearestCity',
//     stateProvince: 'stateProvince',
//     timeZone: 'timeZone',
//     latitude: 'latitude',
//     longitude: 'longitude',
//     plantCapPoi: 'plantCapPoi',
//     onSiteStorage: 'onSiteStorage',
//     plantOwnershipStatus: 'plantOwnershipStatus',
//     effectiveDate: 'effectiveDate',
//   },
// ]

export const getWind2SubgroupXML = data => {
  if (!data || data.length === 0) {
    return ''
  }
  const xmlString = []
  xmlString.push('<WindSubGroupList>')

  data.forEach(element => {
    xmlString.push('\n\t<WindSubGroup>')
    element.entityId &&
      xmlString.push('\n\t\t<EntityID>' + element.entityId + '</EntityID>')
    element.plantId &&
      xmlString.push('\n\t\t<PlantID>' + element.plantId + '</PlantID>')
    element.groupIdName &&
      xmlString.push(
        '\n\t\t<GroupIDName>' + element.groupIdName + '</GroupIDName>'
      )
    element.subgroupName &&
      xmlString.push(
        '\n\t\t<SubGroupName>' + element.subgroupName + '</SubGroupName>'
      )
    element.subgroupName &&
      xmlString.push(
        '\n\t\t<SubGroupID>' + element.subgroupId + '</SubGroupID>'
      )
    element.elevation &&
      xmlString.push(
        '\n\t\t<SubgrpElevation>' + element.elevation + '</SubgrpElevation>'
      )
    element.windRegime &&
      xmlString.push('\n\t\t<WRegime>' + element.windRegime + '</WRegime>')
    element.annualAvgWindspeed &&
      xmlString.push('\n\t\t<AAWS>' + element.annualAvgWindspeed + '</AAWS>')
    element.scadaManufacturer &&
      xmlString.push(
        '\n\t\t<SCADAMfr>' + element.scadaManufacturer + '</SCADAMfr>'
      )
    element.scadaModel &&
      xmlString.push('\n\t\t<SCADAMdl>' + element.scadaModel + '</SCADAMdl>')
    element.commissionDate &&
      xmlString.push('\n\t\t<COD>' + element.commissionDate + '</COD>')
    element.numberTurbines &&
      xmlString.push(
        '\n\t\t<TurbineCount>' + element.numberTurbines + '</TurbineCount>'
      )
    element.trubineSystemMw &&
      xmlString.push(
        '\n\t\t<SystemMW>' + element.trubineSystemMw + '</SystemMW>'
      )
    element.maxTurbineCapacity &&
      xmlString.push(
        '\n\t\t<MaxTurbineCap>' +
          element.maxTurbineCapacity +
          '</MaxTurbineCap>'
      )
    element.trubineManufacturer &&
      xmlString.push(
        '\n\t\t<TurbineMfr>' + element.trubineManufacturer + '</TurbineMfr>'
      )
    element.trubineModel &&
      xmlString.push(
        '\n\t\t<TurbineMdl>' + element.trubineModel + '</TurbineMdl>'
      )
    element.trubineModelVersion &&
      xmlString.push(
        '\n\t\t<TurbineMdlVer>' +
          element.trubineModelVersion +
          '</TurbineMdlVer>'
      )
    element.trubineType &&
      xmlString.push(
        '\n\t\t<TurbineType>' + element.trubineType + '</TurbineType>'
      )
    element.rotorHeight &&
      xmlString.push(
        '\n\t\t<RotorHeight>' + element.rotorHeight + '</RotorHeight>'
      )
    element.rotorDiameter &&
      xmlString.push(
        '\n\t\t<RotorDiam>' + element.rotorDiameter + '</RotorDiam>'
      )
    element.cutInWindspeed &&
      xmlString.push(
        '\n\t\t<CutinSpd>' + element.cutInWindspeed + '</CutinSpd>'
      )
    element.lowCutOutWindspeed &&
      xmlString.push(
        '\n\t\t<LowCutoutSpd>' + element.lowCutOutWindspeed + '</LowCutoutSpd>'
      )
    element.highCutOutWindspeed &&
      xmlString.push(
        '\n\t\t<HighCutoutSpd>' +
          element.highCutOutWindspeed +
          '</HighCutoutSpd>'
      )
    element.turbulenceIntensity &&
      xmlString.push(
        '\n\t\t<TurbIntensity>' +
          element.turbulenceIntensity +
          '</TurbIntensity>'
      )
    element.windShearId &&
      xmlString.push('\n\t\t<WindShear>' + element.windShearId + '</WindShear>')
    element.refAnemometerHeight &&
      xmlString.push(
        '\n\t\t<ReferenceAnemom>' +
          element.refAnemometerHeight +
          '</ReferenceAnemom>'
      )
    element.minOperatingTemp &&
      xmlString.push(
        '\n\t\t<MinOpTemp>' + element.minOperatingTemp + '</MinOpTemp>'
      )
    element.maxOperatingTemp &&
      xmlString.push(
        '\n\t\t<MaxOpTemp>' + element.maxOperatingTemp + '</MaxOpTemp>'
      )
    element.subgroupOwnershipStatus &&
      xmlString.push(
        '\n\t\t<SubGrpOwnStatus>' +
          element.subgroupOwnershipStatus +
          '</SubGrpOwnStatus>'
      )
    element.effectiveDate &&
      xmlString.push(
        '\n\t\t<StatusEffDate>' + element.effectiveDate + '</StatusEffDate>'
      )
    xmlString.push('\n\t</WindSubGroup>')
  })
  xmlString.push('\n</WindSubGroupList>')
  return xmlString.join('')
}

export const getWindStorageXML = data => {
  if (data.length <= 0) return ''
  const xmlString = []
  xmlString.push('<WindEnergyStorageList>')
  data.forEach(d => {
    xmlString.push('\n\t<WindEnergyStorage>')
    xmlString.push(
      d.entityId && '\n\t\t<EntityID>' + d.entityId + '</EntityID>'
    )
    xmlString.push(d.plantId && '\n\t\t<PlantID>' + d.plantId + '</PlantID>')
    xmlString.push(
      d.storageGroupId &&
        '\n\t\t<StorageGroupID>' + d.storageGroupId + '</StorageGroupID>'
    )
    xmlString.push(
      d.storageGroupName &&
        '\n\t\t<StorageGroupName>' + d.storageGroupName + '</StorageGroupName>'
    )
    xmlString.push(
      d.storageGroupEiaCode &&
        '\n\t\t<StorageEIACode>' + d.storageGroupEiaCode + '</StorageEIACode>'
    )
    xmlString.push(
      d.storageIsoResourceId &&
        '\n\t\t<StorageISORID>' + d.storageIsoResourceId + '</StorageISORID>'
    )
    xmlString.push(
      d.storageType && '\n\t\t<StorageType>' + d.storageType + '</StorageType>'
    )
    xmlString.push(
      d.nameplateCapacity &&
        '\n\t\t<StorageCap>' + d.nameplateCapacity + '</StorageCap>'
    )
    xmlString.push(
      d.nameplateEnergy &&
        '\n\t\t<StorageEnergy>' + d.nameplateEnergy + '</StorageEnergy>'
    )
    xmlString.push(
      d.connectionType &&
        '\n\t\t<StorageConnType>' + d.connectionType + '</StorageConnType>'
    )
    xmlString.push(
      d.chargeableFromGrid &&
        '\n\t\t<GridCharge>' + d.chargeableFromGrid + '</GridCharge>'
    )
    xmlString.push(
      d.storageManufacturer &&
        '\n\t\t<StorageManuf>' + d.storageManufacturer + '</StorageManuf>'
    )
    xmlString.push(
      d.storageModel &&
        '\n\t\t<StorageModl>' + d.storageModel + '</StorageModl>'
    )
    xmlString.push(
      d.commisionDate &&
        '\n\t\t<StorageCommDate>' + d.commisionDate + '</StorageCommDate>'
    )
    xmlString.push(
      d.storageInvManufacturer &&
        '\n\t\t<StorageInvManuf>' +
          d.storageInvManufacturer +
          '</StorageInvManuf>'
    )
    xmlString.push(
      d.storageInvModel &&
        '\n\t\t<StorageInvModel>' + d.storageInvModel + '</StorageInvModel>'
    )
    xmlString.push(
      d.storageOwnershipStatus &&
        '\n\t\t<StorageOwnStatus>' +
          d.storageOwnershipStatus +
          '</StorageOwnStatus>'
    )
    xmlString.push(
      d.effectiveDate &&
        '\n\t\t<StorageStatusEffDate>' +
          d.effectiveDate +
          '</StorageStatusEffDate>'
    )
    xmlString.push('\n\t</WindEnergyStorage>')
  })
  xmlString.push('\n</WindEnergyStorageList>')
  return xmlString.filter(f => !!f).join('')
}

export const getWindStoragePerformanceXML = data => {
  if (data.length <= 0) return ''

  const xmlString = []
  xmlString.push('<EnergyStoragePerformanceList>')

  data.forEach(d => {
    xmlString.push('\n\t<EnergyStoragePerformance>')
    xmlString.push(d.plantId && '\n\t\t<PlantID>' + d.plantId + '</PlantID>')
    xmlString.push(
      d.storageGroupId &&
        '\n\t\t<StorageGroupID>' + d.storageGroupId + '</StorageGroupID>'
    )
    xmlString.push(d.month && '\n\t\t<ReptMonth>' + d.month + '</ReptMonth>')
    xmlString.push(d.year && '\n\t\t<ReptYear>' + d.year + '</ReptYear>')
    xmlString.push(
      d.storageGroupAvailability &&
        '\n\t\t<SGAvailStatus>' +
          d.storageGroupAvailability +
          '</SGAvailStatus>'
    )
    xmlString.push(d.chargeMwh && '\n\t\t<ChgMWh>' + d.chargeMwh + '</ChgMWh>')
    xmlString.push(
      d.dischargeMwh && '\n\t\t<DischgMWh>' + d.dischargeMwh + '</DischgMWh>'
    )
    xmlString.push(d.chargeHrs && '\n\t\t<ChgHrs>' + d.chargeHrs + '</ChgHrs>')
    xmlString.push(
      d.dischargeHrs && '\n\t\t<DischgHrs>' + d.dischargeHrs + '</DischgHrs>'
    )
    xmlString.push(d.foHrs && '\n\t\t<StorageFOH>' + d.foHrs + '</StorageFOH>')
    xmlString.push(d.moHrs && '\n\t\t<StorageMOH>' + d.moHrs + '</StorageMOH>')
    xmlString.push(d.poHrs && '\n\t\t<StoragePOH>' + d.poHrs + '</StoragePOH>')
    xmlString.push('\n\t</EnergyStoragePerformance>')
  })

  xmlString.push('\n</EnergyStoragePerformanceList>')

  return xmlString.filter(f => !!f).join('')
}
